import React from 'react';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import {Box, Paper, Typography} from '@material-ui/core';
import {IDepotStatistics} from 'constants/interfaces';
import {FunnelChartData} from 'screens/Dashboard/Analytics/AnalyticsFunnelChart';

const PIE_COLORS = ['#2f7d78', '#56a36c', '#9ccfba', '#c8e6d8'];

const lshRenderPieLabel = (props: {percent?: number}) =>
  `${Math.round(Number(props.percent || 0) * 100)}%`;

export type PieChartData = {
  name: string;
  value: number;
  valueFormatted: number | string;
}[];
export function AnalyticsPieChart(props: {data: PieChartData}) {
  const sumOfDataValues = props.data
    .map((item) => item.value)
    .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
  const noData = sumOfDataValues == 0;
  if (noData)
    return (
      <Box className="analytics-chart-empty">
        <Typography variant="body2" color="textSecondary">
          No data available
        </Typography>
      </Box>
    );
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={props.data}
          nameKey="name"
          dataKey="value"
          cx="58%"
          cy="50%"
          innerRadius="55%"
          isAnimationActive={true}
          outerRadius="82%"
          paddingAngle={2}
          label={lshRenderPieLabel}
          labelLine={false}
          legendType="circle"
        >
          {props.data.map((entry, index) => (
            <Cell
              key={`cell-${entry.name}`}
              fill={PIE_COLORS[index % PIE_COLORS.length]}
            />
          ))}
        </Pie>
        <Legend
          align="left"
          iconSize={8}
          iconType="circle"
          layout="vertical"
          verticalAlign="middle"
        />
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </ResponsiveContainer>
  );
}

function CustomTooltip(props: {
  active?: boolean;
  payload?: Array<{payload: {name: string; valueFormatted: number | string}}>;
}) {
  if (!props.active || !props.payload?.length) return null;
  return (
    <Paper variant="outlined" className="recharts-custom-tooltip">
      <Typography className="title">{props.payload[0].payload.name}</Typography>
      <Typography className="value">
        {props.payload[0].payload.valueFormatted}
      </Typography>
    </Paper>
  );
}

export const toQuoteTypeData = (stats: IDepotStatistics): FunnelChartData => [
  {
    name: 'Pending',
    value: stats.pendingQuotesCount,
    valueFormatted: stats.pendingQuotesCount,
  },
  {
    name: 'Complete',
    value: stats.completeQuotesCount,
    valueFormatted: stats.completeQuotesCount,
  },
  {
    name: 'Rejected',
    value: stats.rejectedQuotesCount,
    valueFormatted: stats.rejectedQuotesCount,
  },
];

export const toOrderTypeData = (stats: IDepotStatistics): FunnelChartData => [
  {
    name: 'Unpaid',
    value: stats.unpaidInvoicesCount,
    valueFormatted: stats.unpaidInvoicesCount,
  },
  {
    name: 'Paid',
    value: stats.paidInvoicesCount,
    valueFormatted: stats.paidInvoicesCount,
  },
];
